<template>
  <v-card flat class="settings-card">
    <v-container>
      <graph-and-grid
        Title="Call Log"
        DisplayingText="calls"
        :Headers="headers"
        ApiPath="/reporting"
        :SearchLocal="true"
        GetParamType="call"
        GetParamName="log"
        GetParamSearchName="search_log"
      >
      </graph-and-grid>
    </v-container>
  </v-card>
</template>

<script>
import GraphAndGrid from "../../reports/shared/GraphAndGrid.vue";

export default {
  name: "CallLog",
  components: {
    GraphAndGrid
  },
  directives: {},
  data: function() {
    return {
      headers: [
        {
          text: "",
          align: "start",
          value: "callIcon",
          width: "1%"
        },
        {
          text: "Start Time",
          value: "startTime",
          width: "25%"
        },
        {
          text: "From",
          value: "from",
          width: "24%"
        },
        {
          text: "To",
          value: "to",
          width: "24%"
        },
        {
          text: "Call Length",
          value: "durationSeconds",
          width: "10%"
        },
        {
          text: "",
          value: "recording",
          width: "5%"
        },
        {
          text: "Action",
          value: "action",
          width: "1%"
        }
      ]
    };
  },
  computed: {},
  async created() {},
  methods: {},
  watch: {}
};
</script>

<style scoped lang="stylus"></style>
